export default __webpack_public_path__ + "static/media/project2.66e8ce70.png";